import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

const SOCIAL_LINKS = [
  { label: 'Facebook', href: 'https://facebook.com/zilacab', icon: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /> },
  { label: 'Instagram', href: 'https://instagram.com/zilacab', icon: <><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></> },
  { label: 'YouTube', href: 'https://youtube.com/@zilacab', icon: <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /> },
  { label: 'WhatsApp', href: 'https://wa.me/919800000000', icon: <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /> },
];

const SERVICE_LINKS = [
  { to: '/', label: 'One-Way Taxi' },
  { to: '/services?tab=taxipool', label: 'TaxiPool' },
  { to: '/services?tab=hourly', label: 'Hourly Rental' },
  { to: '/services?tab=tours', label: 'Tour Packages' },
  { to: '/services?tab=wedding', label: 'Wedding Fleet' },
  { to: '/services?tab=shifting', label: 'House Shifting' },
];

const COMPANY_LINKS = [
  { to: '/about', label: 'About Us' },
  { to: '/drive', label: 'Drive with Us' },
  { to: '/drive', label: 'Partner with Us' },
  { to: '/about', label: 'Careers' },
  { to: '/about', label: 'Press / Media' },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        {/* Brand column */}
        <div className="footer__col footer__brand">
          <div className="footer__logo-wrap">
            <Logo size="sm" />
          </div>
          <p className="footer__tagline">
            Bihar ka sabse bharosemand cab service — har zile mein, har samay, sirf ek taraf ka kiraya.
          </p>
          <div className="footer__socials">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                className="footer__social-btn"
                aria-label={s.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill={s.label === 'Instagram' ? 'none' : 'currentColor'} stroke={s.label === 'Instagram' ? 'currentColor' : undefined} strokeWidth={s.label === 'Instagram' ? '2' : undefined} strokeLinecap={s.label === 'Instagram' ? 'round' : undefined} strokeLinejoin={s.label === 'Instagram' ? 'round' : undefined}>
                  {s.icon}
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* Services column */}
        <div className="footer__col">
          <h5 className="footer__heading">Services</h5>
          <ul className="footer__links">
            {SERVICE_LINKS.map((s) => (
              <li key={s.label}><Link to={s.to}>{s.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Company column */}
        <div className="footer__col">
          <h5 className="footer__heading">Company</h5>
          <ul className="footer__links">
            {COMPANY_LINKS.map((c) => (
              <li key={c.label}><Link to={c.to}>{c.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Contact column */}
        <div className="footer__col">
          <h5 className="footer__heading">Contact</h5>
          <ul className="footer__links">
            <li><a href="tel:1800XXXXXXX">1800-XXX-XXXX</a></li>
            <li><a href="mailto:hello@zilacab.com">hello@zilacab.com</a></li>
            <li><a href="https://wa.me/919800000000" target="_blank" rel="noopener noreferrer">WhatsApp us</a></li>
            <li><a href="https://zilacab.com">zilacab.com</a></li>
            <li><Link to="/support">Terms &amp; Privacy</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <span className="footer__copyright">
          &copy; 2025 ZilaCab &middot; Made with &hearts; for Bihar &middot; All rights reserved
        </span>
        <span className="footer__badge">
          Bihar ka Sabse Bharosemand Travel Partner
        </span>
      </div>
    </footer>
  );
};

export default Footer;
